import { USER_KEY } from '../constants'
import getSelectedChain from './getSelectedChain'

export default () => {
  // Admin/revenda escolhem a rede na barra; funcionário de rede herda a do próprio
  // cadastro e não tem seletor. A escolha vem primeiro porque o perfil traz chainId
  // null para admin.
  const { chainId } = getSelectedChain()
  if (chainId) { return chainId }

  return JSON.parse(localStorage.getItem(USER_KEY) || '{}').chainId
}
